Ext.define('SA.view.sidebar.business.searcheditor.ConditionRow', {
    alias: 'widget.business-condition-row',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-business-editor-condition-row',

    items: [
        {
            xtype: 'combo-button',
            autoSelectFirstValue: true,
            cls: 'sa-business-editor-value-combo',
            height: 54,
            itemId: 'fieldCombo',
            textField: 'text',
            valueField: 'id',
            width: 140,

            listeners: {
                boxready(field) {
                    field.up('[syncFields]').syncFields(field);

                    field.on('change', field => field.up('[syncFields]').syncFields(field));
                }
            },

            buildItems() {
                var Businesses = SA.data.BusinessSearches,
                    country = SA.AppController.getCurrentCountryCode(),
                    fields = [
                        {text: 'Name', id: 'name'},
                        {text: 'SIC', id: 'sic'},
                        {text: 'NAICS', id: 'naics'}
                    ];

                if (Businesses.isFieldAllowed(country, 'local_employees')) {
                    fields.push({text: '# of local employees', id: 'numberOfEmployees'});
                }

                if (Businesses.isFieldAllowed(country, 'sales_volume')) {
                    fields.push({text: 'Sales volume', id: 'salesVolume'});
                }

                return fields;
            }
        }, {
            xtype: 'combo-button',
            autoSelectFirstValue: true,
            cls: 'sa-business-editor-operator-combo',
            height: 54,
            itemId: 'operatorCombo',
            textField: 1,
            valueField: 0,
            width: 130
        }, {
            xtype: 'sa-textfield',
            allowBlank: false,
            blankText: 'This value is required',
            cls: 'sa-business-editor-value-field',
            itemId: 'valueField',
            maskRe: /./, 
            validateOnChange: false,

            listeners: (function() {
                var listItemClickInProgress = false,
                    list, hideTimer;

                return {
                    blur(field) {
                        if (listItemClickInProgress) {
                            return;
                        }

                        onChange(field);

                        hideTimer = setTimeout(hideList, 20);
                    },

                    change(field) {
                        onChange(field);
                        field.clearInvalid();
                        updateList(field);
                    },

                    destroy() {
                        list = null;
                    },

                    focus(field) {
                        if (!field.listType) {
                            return;
                        }

                        field.clearInvalid();

                        clearTimeout(hideTimer);

                        updateList(field);

                        list.showBy(field.inputEl, 'tl-bl?');
                    }
                };

                function createList() {
                    return Ext.widget({
                        xtype: 'business-code-list',

                        listeners: {
                            blur() {
                                hideTimer = setTimeout(hideList, 20);
                            },

                            focus() {
                                clearTimeout(hideTimer);
                            },

                            'mousedown:item': function() {
                                listItemClickInProgress = true;

                                Ext.getDoc().on('mouseup', function() {
                                    listItemClickInProgress = false;
                                }, null, {single: true});
                            }
                        }
                   });
                }

                function updateList(field) {
                    var type = field.listType,
                        value = field.getValue().trim(),
                        data = [],
                        country = SA.AppController.getCurrentCountryCode(),
                        all, query, regex, longest, shortest, maxLength;

                    if (!type) {
                        return;
                    }

                    if (!list) {
                        list = field.list = createList();
                    }

                    list.field = field;

                    if (type === 'sic') {
                        all = SA.data.SicCodes.forCountry(country);
                    }
                    else {
                        all = SA.data.NaicsCodes.forCountry(country);
                    }

                    if (!/^\d*$/.test(value)) {
                        query = Ext.Array.clean(value.toLowerCase().split(/\W/));
                    }

                    if (query && query.length) {
                        regex = new RegExp(query.join('|'), 'gi');

                        all.forEach(entry => {
                            var code = entry[0],
                                text = entry[1],
                                testValue = code + ' ' + text.toLowerCase();

                            if (query.some(part => !testValue.includes(part))) {
                                return;
                            }

                            text = text.replace(regex, match => '{' + match + '}');
                            text = [
                                '<span class="sa-business-editor-code-list-item-code">',
                                    code.replace(regex, match => '{' + match + '}'),
                                '</span> - ' + Ext.util.Format.htmlEncode(text)
                            ].join('');
                            text = text.replace(/\{/g, '<mark class="sa-business-editor-search-highlight">').replace(/\}/g, '</mark>');

                            data.push({code, text});
                        });

                        while (data.length > 50) {
                            longest = 0;
                            shortest = 8;

                            data.forEach(entry => {
                                var len = entry.code.length;

                                if (len > longest) {
                                    longest = len;
                                }

                                if (len < shortest) {
                                    shortest = len;
                                }
                            });

                            if (shortest === longest) {
                                break;
                            }

                            data = data.filter(entry => entry.code.length !== longest);
                        }
                    }
                    else {
                        maxLength = Math.ceil((value.length + 1) / 2) * 2;

                        if (type === 'sic' && maxLength === 6) {
                            maxLength = 8;
                        }

                        all.forEach(entry => {
                            var code = entry[0],
                                text;

                            if (code.length <= maxLength && code.indexOf(value) === 0 || value.indexOf(code) === 0) {
                                text = '<span class="sa-business-editor-code-list-item-code">' + code + '</span>';

                                if (code === value) {
                                    text = '<mark class="sa-business-editor-search-highlight">' + text + '</mark>';
                                }

                                text += ' - ' + Ext.util.Format.htmlEncode(entry[1]);

                                data.push({code, text});
                            }
                        });
                    }

                    list.update(data);

                    list.setHeight(null);
                    list.setWidth(null);
                }

                function hideList() {
                    if (list) {
                        list.hide();
                    }
                }

                function onChange(valueField) {
                    if (Ext.isEmpty(valueField.getErrors())) {
                        valueField.clearInvalid();
                    }

                    if (valueField.listType) {
                        valueField.up('[syncFields]').syncFields(valueField);
                    }

                    valueField.up('[updateDoneButton]').updateDoneButton();
                }
            })(),

            getRefItems() {
                return this.list ? [this.list] : [];
            }
        }, {
            xtype: 'remove-button',
            autoEl: {tag: 'button'},
            tooltip: 'Remove this condition',

            handler() {
                var conditions = this.up('business-conditions'),
                    row = this.up('business-condition-row');

                destroyBooleanCmp();

                row.destroy();

                conditions.refresh();

                function destroyBooleanCmp() {
                    var dom = row.el.dom,
                        sibling = dom && (dom.previousSibling || dom.nextSibling),
                        cmp = Ext.getCmp(sibling && sibling.id);

                    Ext.destroy(cmp);
                }
            }
        }
    ],

    getCondition() {
        var field = this.down('#fieldCombo').getValue(),
            value = this.down('#valueField').getValue();

        switch (field) {
            case 'numberOfEmployees':
            case 'salesVolume':
                value = +value;
        }

        return [
            this.down('#operatorCombo').getValue(),
            field,
            value
        ];
    },

    setCondition(condition) {
        this.down('#operatorCombo').setValue(condition[0]);
        this.down('#fieldCombo').setValue(condition[1]);
        this.down('#valueField').setValue(condition[2]);
    }
});
